import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 915,
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,
  outline: "none",
  overflow: "hidden",
  [theme.breakpoints.down("lg")]: { width: 715 },
  [theme.breakpoints.down("md")]: { width: 580 },
  [theme.breakpoints.down("sm")]: { width: 350 },
  [theme.breakpoints.down("xs")]: { width: 230 },
}));

export const ModalHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  background: theme.palette.custom.primary,
  padding: "23px 16px",
  alignItems: "center",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  gap: "18px",
  alignItems: "center",
  // flexWrap: "wrap",
}));
export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.profileSuccess,
  paddingTop: "24px",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.small.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  color: theme.palette.custom.profileSuccessDes,
}));
export const ButtonWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 24px",
  borderTop: "1px solid #E5E7EB",
  background: theme => theme.palette?.custom?.virtualSuccess || "#f5f9ff",
  flexShrink: 0,
}));
export const StyledTypographyVirtual = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.extraLarge.fontSize,
  color: theme.palette.custom.white,
  fontWeight: theme.typography.fontWeight.semiBold,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledTypographyDes = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.white,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
}));
export const StyledTypographyLocker = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.small.fontSize,
  color: theme.palette.custom.virtualTitle,
  fontWeight: theme.typography.fontWeight.medium,
  marginBottom: "12px",

  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
}));
export const StyledTypographyByTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.virtualDescription,
  fontWeight: theme.typography.fontWeight.medium,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.small.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.blackColor,
  cursor: "pointer",
  width: 38,
  height: 38,
}));

export const StyledLiTop = styled("li")(({ theme }) => ({
  paddingTop: "20px",
  [theme.breakpoints.down("md")]: {
    paddingTop: "16px",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "12px",
  },
}));
export const StyledUl = styled("ul")(() => ({
  marginLeft: "20px",
}));
export const StyledSpanColor = styled("span")(({ theme }) => ({
  color: theme.palette.custom.danger,
}));
export const StyledTypographyTerms = styled(Typography)(({ theme }) => ({
  marginTop: "20px",
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.virtualDescription,
  fontWeight: theme.typography.fontWeight.medium,

  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.regular.fontSize,
    marginTop: "0px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.small.fontSize,
  },
}));
export const StyledTypographyLiTopic = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.virtualDescription,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.small.fontSize,
  },
}));
export const StyledBoxInnerText = styled(Box)(({ theme }) => ({
  border: "1px solid #126ABC",
  padding: "12px",
  background: theme.palette.custom.white,
  overflowY: "auto",
  flex: 1,
  minHeight: 0,
  color: theme.palette.custom.virtualDescription,
}));
export const StyledBoxCondition = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.virtualSuccess,
  padding: "18px 24px",
  flex: 1,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
}));
export const StyledBoxPoint = styled(Box)(({ theme }) => ({
  padding: "24px",

  [theme.breakpoints.down("md")]: {
    padding: "18px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "12px",
  },
}));

export const StyledImg = styled("img")(({ theme }) => ({
  height: "55px",
  width: "55px",

  [theme.breakpoints.down("lg")]: {
    height: "35.25px",
    width: "35.25px",
  },
}));
